module.exports = __webpack_public_path__ + "img/microsoft-authenticator.ebbde6a1.svg";